export default __webpack_public_path__ + "static/media/alba-logo.817ae271.svg";